const STEP_EPSILON = 1e-9;

function numericSeed(sources: readonly string[]): number[] | null {
  const values: number[] = [];
  for (const src of sources) {
    if (src === "" || src.startsWith("=")) return null;
    const n = Number(src);
    if (Number.isNaN(n)) return null;
    values.push(n);
  }
  return values;
}

export function linearSeries(sources: readonly string[]): ((index: number) => string) | null {
  const values = numericSeed(sources);
  if (!values || values.length < 2) return null;
  const step = values[1]! - values[0]!;
  for (let i = 2; i < values.length; i++) {
    if (Math.abs(values[i]! - values[i - 1]! - step) > STEP_EPSILON * Math.max(1, Math.abs(step))) return null;
  }
  const start = values[0]!;
  return (index) => String(Number((start + step * index).toPrecision(12)));
}
